import { actionTypes } from '../../types';

// Action creator for generating OTP request
export const campaignList = (payload) => ({
    type: actionTypes.CAMPAIGN_LIST_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const campaignListSuccess = (payload) => ({
    type: actionTypes.CAMPAIGN_LIST_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const campaignListFailure = (payload) => ({
    type: actionTypes.CAMPAIGN_LIST_FAILURE,
    payload,
});

export const campaignListReset = () => ({
    type: actionTypes.CAMPAIGN_LIST_RESET,
});

// Action creator for resetting all OTP generation reducer
export const campaignListResetAll = () => ({
    type: actionTypes.CAMPAIGN_LIST_RESET_ALL,
});
